// Guarda a última tela útil da área da empresa para que o boot frio do PWA
// (Android mata o app em background e ele reabre no start_url do manifest)
// devolva o usuário onde ele estava, em vez da tela de escolha de perfil.
//
// CONTRATO COM QUEM CONSOME: `lerUltimaRota` garante apenas que o `name` é uma
// string não vazia — não que ele ainda exista. O valor no localStorage sobrevive
// a deploys, então uma rota renomeada continua gravada aqui. Como nenhum dos
// arquivos de rota tem rota coringa (`*`), navegar para um nome inexistente
// resolve para `matched: []`: o `canNavigate` do guard reprova a rota vazia e o
// usuário termina em "acesso negado" — beco sem saída logo ao abrir o app, e no
// app das lojas não há barra de endereço para ele se salvar. Antes de navegar,
// confirme com `router.resolve({ name }).route.matched.length > 0` e, se não
// resolver, caia na tela padrão e chame `limparUltimaRota()`.
//
// Essa checagem não pode morar aqui: importar o router neste módulo fecharia o
// ciclo de importação circular documentado em `baseRoute.js`.

const CHAVE = 'veltacar:ultimaRota'

// Telas que passam pelo corte de `meta.resource` (são internas, exigem sessão)
// mas não servem como destino de restauração: são becos sem saída.
const ROTAS_IGNORADAS = [
    'naoAutorizado',
    'naoAutorizado-client',
    'planoBloqueado',
    'error-404',
]

const normalizarObjeto = (valor) => (
    valor && typeof valor === 'object' && !Array.isArray(valor) ? valor : {}
)

export function gravarUltimaRota(route) {
    try {
        if (!route || !route.name) return
        if (ROTAS_IGNORADAS.includes(route.name)) return
        if (!String(route.path || '').startsWith('/sistema/empresa')) return

        // Só grava tela interna: toda rota pública/sem sessão declara
        // `resource: "auth"`, então este corte exclui login, cadastro, termo de
        // uso e afins automaticamente — inclusive telas públicas criadas no
        // futuro, que uma lista de nomes esqueceria de cobrir.
        if (!route.meta?.resource || route.meta.resource === 'auth') return

        localStorage.setItem(CHAVE, JSON.stringify({
            name: route.name,
            params: route.params || {},
            query: route.query || {},
        }))
    } catch (e) {
        // localStorage indisponível (modo privativo, cota cheia): a
        // restauração é uma conveniência, não pode derrubar a navegação.
    }
}

export function lerUltimaRota() {
    try {
        const bruto = localStorage.getItem(CHAVE)
        if (!bruto) return null

        const rota = JSON.parse(bruto)
        if (!rota || typeof rota.name !== 'string' || rota.name === '') return null
        // A lista continua valendo na leitura: bundles antigos gravaram telas
        // que hoje são recusadas na escrita.
        if (ROTAS_IGNORADAS.includes(rota.name)) return null

        return {
            name: rota.name,
            params: normalizarObjeto(rota.params),
            query: normalizarObjeto(rota.query),
        }
    } catch (e) {
        return null
    }
}

export function limparUltimaRota() {
    try {
        localStorage.removeItem(CHAVE)
    } catch (e) {
        // idem
    }
}
